import { get, set, toLower } from 'lodash';

class Employer {
    constructor(data) {
        for (const [key, value] of Object.entries(data || {})) {
            set(this, key, value);
        }
    }

    isAtsEmployer() {
        return !!get(this, 'settings.atsType')
            && (get(this, 'settings.showAtsJobId') || get(this, 'settings.showAtsJobUrl'));
    }

    isPaycorEmployer() {
        return toLower(get(this, 'office', '')).indexOf('paycor') >= 0;
    }
}

export default Employer;
